
import { useTranslation } from "react-i18next";
import { AthleteStats as AthleteStatsComponent } from "@/components/athlete/AthleteStats";
import { AthleteBrandHeader } from "@/components/athlete/AthleteBrandHeader";

const AthleteStats = () => {
  const { t } = useTranslation(["athlete", "common"]);

  return (
    <div className="athlete-page-bg min-h-screen flex flex-col w-full">
      <main className="flex-1 p-4 md:p-6 max-w-7xl mx-auto w-full">
        <AthleteBrandHeader
          title={t('stats.title', { ns: 'athlete' })}
          subtitle={t('stats.subtitle', { ns: 'athlete' })}
          backgroundKey="stats"
        />

        <AthleteStatsComponent />
      </main>
    </div>
  );
};

export default AthleteStats;
